import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImg = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.121 23H7.37666C5.51197 23 4 21.5012 4 19.6527V4.34732C4 2.49883 5.51197 1 7.37666 1H15.8418L20.5 5.63869V19.6527C20.5 21.5012 18.988 23 17.1233 23H17.121Z",
			fill: "#00AB54"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.4976 5.63869H16.7988C16.2745 5.63869 15.8489 5.21911 15.8489 4.6993L15.8418 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2334 17.6552L9.66713 14.0747L11.7999 16.2985L14.4147 11.5806L17.5703 17.6552H7.2334Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.64406 12.1771C9.05963 12.1771 9.39652 11.8432 9.39652 11.4312C9.39652 11.0193 9.05963 10.6853 8.64406 10.6853C8.22849 10.6853 7.8916 11.0193 7.8916 11.4312C7.8916 11.8432 8.22849 12.1771 8.64406 12.1771Z",
			fill: "white"
		})
	]
});
export default SvgImg;
